'use strict';
export function routeConfig($urlRouterProvider, $locationProvider, $stateProvider) {
    'ngInject';
    $stateProvider.state('privacyPolicy', {
        url: '/privacy-policy',
        template: require('./static-pages/privacy-policy.html'),
    });
    $stateProvider.state('termsOfSale', {
        url: '/terms-of-sale',
        template: require('./static-pages/terms-of-sale.html'),
    });
    $stateProvider
        .state('custom404', {
        url: '/404/custom',
        template: require('./404/customOrderForm404.html')
    });
    $stateProvider
        .state('404', {
        url: '/404',
        template: require('./404/generic404.html')
    });
    $urlRouterProvider.otherwise('/404');
    $locationProvider.html5Mode(true);
}
//# sourceMappingURL=app.config.js.map